type Config = {
    triggerElement: string | HTMLDivElement;
    triggerHook: number;
    offset: number;
    duration?: number | string;
};

interface AnimateType {
    sceneList: any[];
    layoutH: number;
    createScene: (config: Config) => any;
    destroy: () => void;
}

export function useAnimate(): AnimateType {
    const sceneList: any[] = [];

    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;

    const createScene = (config: Config) => {
        const scene = new ScrollMagic.Scene(config);
        sceneList.push(scene);
        return scene;
    };

    const destroy = () => {
        sceneList.forEach((scene) => scene.destroy(true));
    };

    return {
        sceneList,
        layoutH,
        createScene,
        destroy,
    };
}
